/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmSpeechListTranscriptionHistory } from "../../funcs/llmSpeechListTranscriptionHistory.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListSpeechToTextHistoryRequest$inboundSchema,
};

export const tool$llmSpeechListTranscriptionHistory: ToolDefinition<
  typeof args
> = {
  name: "llm-speech-list-transcription-history",
  description: `List speech-to-text history

List stored transcriptions for the authenticated user, newest first by default.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmSpeechListTranscriptionHistory(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
